import * as Yup from 'yup';

import i18n from '@/i18n';

export const createUpdatePaymentPlanValidation = () => {
  return Yup.object().shape({
    name: Yup.string().required(i18n.t('nameRequired', { ns: 'common' }))
  });
};
